const STORAGE_KEY = 'eo4eu.themeMode';

export const THEME_CHANGE_EVENT = 'eo4eu-theme-change';

export const THEME_MODES = [
  { label: 'Auto', value: 'auto' },
  { label: 'Dark', value: 'dark' },
  { label: 'Light', value: 'light' },
];

export function getStoredThemeMode() {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    if (value === 'light' || value === 'dark' || value === 'auto') return value;
  } catch (_) {
    // ignore
  }
  return 'auto';
}

export function setStoredThemeMode(mode) {
  try {
    window.localStorage.setItem(STORAGE_KEY, mode);
  } catch (_) {
    // ignore
  }
}

export function getEffectiveTheme(mode) {
  if (mode === 'light' || mode === 'dark') return mode;
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return 'dark';
  return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
}

export function applyThemeMode(mode) {
  const effective = getEffectiveTheme(mode);
  const root = document.documentElement;
  root.dataset.themeMode = mode;
  root.dataset.theme = effective;
  window.dispatchEvent(
    new CustomEvent(THEME_CHANGE_EVENT, { detail: { mode, effective } }),
  );
}

export function initThemeMode() {
  const mode = getStoredThemeMode();
  applyThemeMode(mode);

  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return () => {};

  const media = window.matchMedia('(prefers-color-scheme: light)');
  const onChange = () => {
    const currentMode = getStoredThemeMode();
    if (currentMode !== 'auto') return;
    applyThemeMode('auto');
  };

  if (typeof media.addEventListener === 'function') media.addEventListener('change', onChange);
  else media.addListener(onChange);

  return () => {
    if (typeof media.removeEventListener === 'function') media.removeEventListener('change', onChange);
    else media.removeListener(onChange);
  };
}

